<template>
  <div class="new-product body">
    <el-container>
      <!-- <CustomersAside /> -->

      <el-main>
        <el-card>
          <template slot="header">
            اضافة مورد جديد
          </template>
          <div>
            <el-row :gutter="10">
              <el-col :xl="8" :lg="8" :md="24" :sm="24">
                <div class="searchForm">
                  <label for="">الاسم </label>
                  <el-input
                    class="mt-2 input1"
                    @focus="$event.target.select()"
                    v-model="form.name"
                    @keyup.enter.native="focusNext"
                  ></el-input>
                </div>
              </el-col>
              <el-col :xl="4" :lg="4" :md="12" :sm="12">
                <div class="searchForm">
                  <label for="search">رصيد المورد </label>
                  <el-input
                    class="mt-2 input2"
                    id="account"
                    type="number"
                    @focus="$event.target.select()"
                    v-model="form.account"
                    controls-position="right"
                    @keyup.enter.native="focusNext"
                  ></el-input>
                </div>
              </el-col>
              <el-col :xl="4" :lg="4" :md="12" :sm="12">
                <div class="searchForm">
                  <label for="search"> رقم الهاتف</label>
                  <el-input
                    class="mt-2 input3"
                    id="phone"
                    @focus="$event.target.select()"
                    v-model="form.phone"
                    @keyup.enter.native="focusNext"
                  ></el-input>
                </div>
              </el-col>
              <el-col :xl="8" :lg="8" :md="12" :sm="12">
                <div class="searchForm">
                  <label for="search"> العنوان </label>
                  <el-input
                    class="mt-2 input4"
                    id="address"
                    @focus="$event.target.select()"
                    v-model="form.address"
                    @keyup.enter.native="focusNext"
                  ></el-input>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="mt-3">
            <el-row :gutter="10">
              <el-col :xl="4" :lg="4" :md="12" :sm="12">
                <el-button type="warning" @click="addNewSupplier()">
                  تسجيل</el-button
                >
              </el-col>
            </el-row>
          </div>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>
<script>
// import CustomersAside from "@/components/CustomersAside.vue";
import axiosApi from "@/plugins/axios.js";

export default {
  name: "NewCustomer",
  // components: { CustomersAside },
  data() {
    return {
      index: 1,
      false: false,
      form: {
        name: "",

        inventory_id: 1,
        phone: "",
        account: 0,
        address: "",
      },
    };
  },
  created() {},
  mounted() {},

  methods: {
    focusNext() {
      if (this.index < 4) {
        this.index += 1;
      } else {
        this.index = 1;
      }
      let input = ".input" + this.index + " input";
      console.log(input);
      setTimeout(() => {
        document.querySelector(input).focus();
      }, 100);
    },

    addNewSupplier() {
      axiosApi
        .post("suppliers", this.form)
        .then(() => {
          this.$notify({
            title: "تمت العملية بنجاح",
            message: "تم حفظ بيانات المورد بنجاح",
            type: "success",
            duration: 1500,
          });
          setTimeout(() => {
            location.reload();
          }, 500);
        })
        .catch(() => {
          this.$notify({
            title: "حدث خطأ",
            message: "عفوا لم تتم العملية ",
            type: "error",
            duration: 1500,
          });
        });
    },
  },
};
</script>